
export default function About() {
  return (
    <section id="about" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        {/* Title Block */}
        <div className="text-center mb-20">
          <p className="text-xs font-semibold tracking-widest text-gray-500 uppercase mb-4">
            WHO WE ARE
          </p>
          <h2 className="text-6xl font-bold text-[#1a2332] mb-8 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            BUILDING TRUST<br />THROUGH TECHNOLOGY
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
            EL DORADO S.R.L. is dedicated to protecting your digital privacy with cutting-edge VPN technology. Based in Río Grande, Argentina, we develop secure, reliable applications that safeguard your online presence. Our mission is to provide enterprise-level security solutions that are accessible, trustworthy, and built with your privacy as our top priority.
          </p>
        </div>

        {/* Image Composition */}
        <div className="flex gap-6 items-center">
          <div className="w-[38%]">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/5bd8a131b3ff5761d4872efd2adedacb.jpg"
                alt="Technology Visualization"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
          <div className="w-[58%]">
            <div className="rounded-3xl overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20office%20technology%20infrastructure%20with%20servers%20and%20network%20equipment%2C%20professional%20tech%20company%20workspace%2C%20clean%20organized%20data%20center%20environment%2C%20blue%20lighting%20atmosphere%2C%20corporate%20technology%20setting%2C%20secure%20digital%20infrastructure%2C%20contemporary%20business%20technology&width=800&height=450&seq=about-img-002&orientation=landscape"
                alt="Technology Infrastructure"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
